// Configuración de la URL del Servidor API
// Descomenta la línea de localhost y comenta la de producción cuando estés en desarrollo.

export const API_BASE_URL = 'https://api.solcito.cubocode.com.ar';
//export const API_BASE_URL = 'http://localhost:3001';
